import React from 'react';
import './portfolio.css';
import IMG1 from '../../assets/portfolio1.jpg';
import IMG2 from '../../assets/portfolio2.jpg';

const data = [
  {
  id:1,
  image: IMG1,
  title:"ChatApp",
  github:'https://github.com/rigers-allaraj/chatApp',
  demo:'https://chat-app-ouki4hfvq-rigers-allaraj.vercel.app/'
  },
  {
  id:2,
  image: IMG2,
  title:"Web scraping",
  github:'https://github.com/rigers-allaraj/Puppeteer-Node-JS',
  demo:'https://github.com/rigers-allaraj/Puppeteer-Node-JS'
  },
]


export default function Portfolio() {
  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>
      <div className="container portfolio__container">        
        {
          data.map(({id,image,title,github,demo}) =>{
            return(
              <article key={id} className='portfolio__item'>
              <div className='portfolio__item-image'>
                <img src={image} alt={title}></img>
              </div>
              <h3>{title}</h3>
             <div className="portfolio__item-cta">
             <a href={github} className='btn btn-animation' target='_blank'>Github</a>
              <a href={demo} className='btn btn-primary btn-animation' target='_blank'>Live demo</a>
             </div>
            </article>
            )
          }
          )
        }
      </div>
    </section>
  )
}
